/* eslint-disable no-param-reassign */
function compile (templateKey, templateContent, Handlebars) {

	Handlebars.templates = Handlebars.templates || {};
	const compiledTemplateContent = Handlebars.compile(templateContent);
	Handlebars.templates[templateKey] = compiledTemplateContent;

}

function bundleHandlebarsTemplates (context, templatePathPrefix) {

	const templateFileMap = ((ctx) => {

		const keys = ctx.keys();
		const values = keys.map(ctx);
		return keys.reduce((o, k, i) => {

			o[`${templatePathPrefix}${k.replace(/^.\//, '').replace(/.html$/, '')}`] = values[i];
			return o;

		}, {});

	})(context);

	const { Handlebars } = window;
	Object.keys(templateFileMap).forEach((templateKey) => {

		compile(templateKey, templateFileMap[templateKey].default, Handlebars);

	});

}

export default bundleHandlebarsTemplates;
